import { SupersededRule } from "@protos/issues/v1/issues";
import {
  SEMGREP_DEV_PRO_ENGINE_INFO_URL,
  SEMGREP_DEV_SECRETS_INFO_URL,
} from "@shared/constants";
import { isSupersededBySecrets } from "@shared/utils";

import { useHasSecretsAccess } from "../useSecretsAccess";
import { useSupersededByRulePathsLink } from "../useSupersededByRulePathsLink";

export const useSupersededHref = (supersededBy: SupersededRule[]) => {
  const { hasSecrets } = useHasSecretsAccess();
  const policyBoardHref = useSupersededByRulePathsLink(supersededBy);
  const isSecrets = isSupersededBySecrets(supersededBy);

  if (isSecrets) {
    if (hasSecrets) {
      // link to filtered secrets policies page
      return policyBoardHref;
    }
    return SEMGREP_DEV_SECRETS_INFO_URL;
  } else {
    // OSS Code -> Pro
    return SEMGREP_DEV_PRO_ENGINE_INFO_URL;
  }
};
